<template>
  <div class="container">
    <div class="navi">
        <div class="back"><a @click="close"><img :src="`${publicPath}/images/icons/chevron-left.svg`" class="icon"></a></div>
        <div class="title"><span>プレート選択</span></div>
    </div>
    <div class="answers">
      <a v-for="(plate, index) in currentPlates()" class="answer" :key="index" @click="select(plate, index)">
          <img v-if="plateNumber >= 0" :src="answerImagePath(plate)">
          <span v-else :class="customClassName(index)">{{ plate }}</span>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AnswerListComponent',
  props: {
    plateNumber: {
      default: 0,
      type: Number
    }
  },
  methods: {
    select: function(plate, index) {
      this.changeView({
        viewName: 'AnswerSlideComponent',
        answerName: plate,
        answerIndex: index,
        plateNumber: this.plateNumber,
        transitionName: 'bottom'
      })
    },
    close: function() {
      this.changeView({
        viewName: 'PlatesComponent',
        transitionName: 'left'
      })
    }
  }
}
</script>
